export const replaceImagesWithInlineSVG = function (selector = 'img.svg') {
  const svgs = Array.from(document.querySelectorAll(selector));
  let loadedCount = 0;

  if (svgs.length === 0) {
    return;
  }

  const handleInlineSVG = () => {
    svgs.forEach((img) => {
      const imgClass = img.getAttribute('class');
      const imgURL = img.getAttribute('src');

      fetch(imgURL)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(data, 'image/svg+xml');
          const svg = svgDoc.querySelector('svg');

          if (svg) {
            if (imgClass) {
              svg.setAttribute('class', `${imgClass} replaced-svg`);
            }

            svg.removeAttribute('xmlns:a');
            if (img.parentNode) {
              img.parentNode.replaceChild(svg, img);
            }
          }
        })
        .catch((err) => {
          console.error(`Failed to fetch SVG from ${imgURL}:`, err);
        });
    });
  };

  svgs.forEach((img) => {
    if (img.complete) {
      loadedCount++;
    } else {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === svgs.length) {
          handleInlineSVG();
        }
      };
    }
  });

  if (loadedCount === svgs.length) {
    handleInlineSVG();
  }
};